import {lazy} from 'react';

export const CurrencyConverterLazy = lazy(() => import(/* webpackChunkName: "currencyConverter" */ '.'));
